if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-cart') && document.querySelector('.cart-subtotal') != null){
  const cartTotal = document.querySelector('.cart-subtotal').dataset.amount;
  const apConfig = {
    priceSelector: '.cart-policies',
    locale: 'en_US',
    currency: 'USD',
    afterpayLogoColor: 'white',
    showUpperLimit: false,
    amount: cartTotal,
    minMaxThreshold: {
      min: 100,
      max: 100000,
    },
  };
  new presentAfterpay(apConfig).init();
}
window.onload = function() {
  if(Object.keys(apConfig).length > 0 && document.querySelector('body').classList.contains('template-product')){
    if(window.innerWidth > 768) {
      const ap = new presentAfterpay(apConfig).init();
    }
    apConfig.priceSelector = '.main-mobile-price-selector';
    new presentAfterpay(apConfig).init();
    var price = document.querySelector('product-form.sticky-content-container .price');
    var config = {childList: true, subtree: true };
  }  
  var intervalStampedInstagram = setInterval(function(){
    if(document.querySelector('body').classList.contains('template-product')){
      if(document.querySelector('.stamped-instagram-media-block-template') != null){
        if(document.querySelectorAll('.stamped-instagram-media-block').length < 2){
          document.querySelector('.hometitle.app_title').classList.add('hidden');
        }else{
          document.querySelector('.hometitle.app_title').classList.remove('hidden');
        }
        clearInterval(intervalStampedInstagram);
      }
    }
  },3000);
}
$(document).ready(function(){
  const customSlider = document.querySelector('.custom-slider-block');
  if(customSlider != null){
    const customSliderConf = document.querySelector('.slider-config').textContent;
    const configuration = JSON.parse(customSliderConf);
    if($('.custom-slider-block').hasClass('slick-slider')){
      $('.custom-slider-block').slick(configuration);
    }else{
      $('.custom-slider-block').owlCarousel(configuration);
    }
  }

  /* lux rave slider on mobile AP 19-03-2025 */
  if ($(window).width() < 480) {
    $('.meet-greet-rows').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      arrows: true,
      dots: false,        
      centerPadding: '80px',
      infinite: true,
    });
  }
  /* lux rave slider on mobile AP 19-03-2025 */
  $('.owl-carousel').owlCarousel({
    loop:false,
    margin:10,
    nav:true,
    dots:false,
    responsive:{
      0:{
        items:2
      },
      600:{
        items:3
      },
      1000:{
        items:5
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.rte a[aria-label]').forEach(link => {
    const visibleText = link.textContent.trim();
    const aria = link.getAttribute('aria-label');
    if (aria && !aria.includes(visibleText)) {
      link.setAttribute('aria-label', `${visibleText} - ${aria}`);
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(function (mutationsList) {
    const img = document.querySelector('pdqproductpromise .pdq-pdp__widget-icon');
    if (img && !img.hasAttribute('alt')) {
      img.setAttribute('alt', 'shipping track icon');
      observer.disconnect(); // Stop observing after it's set
    }
  });

  // Observe the body for dynamic loading of pdqproductpromise
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.querySelectorAll('.rte a:not([href])').forEach(function (a) {
    // Only add role and tabindex if not already present
    if (!a.hasAttribute('role')) {
      a.setAttribute('role', 'button');
    }
    if (!a.hasAttribute('tabindex')) {
      a.setAttribute('tabindex', '0');
    }
  });

  document.querySelectorAll('img.gifimg').forEach(img => {
    setTimeout(() => {
      const gifUrl = img.dataset.gif 
      img.src = gifUrl;
    }, 5000); 
  });
});